import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {Observable} from 'rxjs';
import {ElasticSearchSortValue} from '@models/elastic-search/request/elastic-search-sort-value';
import {ELASTIC_SEARCH_SORT_ORDER} from '@models/elastic-search/request/elastic-search-sort-order.enum';
import {ELASTIC_SEARCH_TYPE} from '@constants/elastic-search/elastic-search-type.enum';
import {ELASTIC_SEARCH_FIELDS} from '@constants/elastic-search/elastic-search-fields.constant';
import {ELASTIC_SEARCH_RETURNED_FIELDS} from '@constants/elastic-search/elastic-search-returned-fields.constant';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';
import {ElasticSearchRequest} from '@models/elastic-search/request/elastic-search-request';
import {ElasticSearchFilterValue} from '@models/elastic-search/request/elastic-search-filter-value';

@Injectable({
  providedIn: 'root'
})
export class MachineryGroupDetailsService {
  private ELASTIC_API_PREFIX = '/api/elastic/';
  private readonly NAME_FIELD: string = 'name';
  private readonly ID_FIELD: string = 'id';
  private readonly USER_NAME_FIELD: string = 'username';
  private readonly MAX_ITEMS_PER_PAGE = 9999;
  private readonly INITIAL_PAGE_NUMBER = 0;

  private readonly BASE_URL: string;
  private readonly MACHINE_GROUP_FIELD: string = 'machineGroup';
  private readonly PARENT_ID_FIELD: string = 'parentId';
  private readonly PARENT_MACHINERY_GROUP_IDS_FIELD: string = 'parentMachineryGroupIds';

  constructor(
      private http: HttpClient,
      private apiLocation: ApiLocationService) {
    this.BASE_URL = this.apiLocation.getLocation();
  }

  public listChildMachineryGroups(machineryGroupId: number | null, whiteListedMachineryGroups: number[] | null): Observable<any> {

    const request = this.generateElasticRequest();
    request.sort = new ElasticSearchSortValue(this.NAME_FIELD, ELASTIC_SEARCH_SORT_ORDER.ASC);
    request.fieldsToSearch = ELASTIC_SEARCH_FIELDS.MACHINERY_GROUP_SEARCH_FIELDS;
    request.fieldsToReturn = ELASTIC_SEARCH_RETURNED_FIELDS.MACHINERY_GROUP_RETURNED_FIELDS;

    if (whiteListedMachineryGroups && whiteListedMachineryGroups.length > 0) {
      request.whiteListFilter = [new ElasticSearchFilterValue(this.ID_FIELD, String(whiteListedMachineryGroups.join(',')))];
    }

    request.filter = [new ElasticSearchFilterValue(this.PARENT_ID_FIELD, String(machineryGroupId))];

    const url: string = this.BASE_URL + this.ELASTIC_API_PREFIX + ELASTIC_SEARCH_TYPE.MACHINERY_GROUP + '/';
    return this.http.post(url, request, HTTPS_REQUEST_OPTIONS);

  }


  public listAssignedUsers(machineryGroupId: number | null, whiteListedMachineryGroups: number[] | null): Observable<any> {

    const request = this.generateElasticRequest();
    request.sort = new ElasticSearchSortValue(this.USER_NAME_FIELD, ELASTIC_SEARCH_SORT_ORDER.ASC);
    request.fieldsToSearch = ELASTIC_SEARCH_FIELDS.USER_SEARCH_FIELDS;
    request.fieldsToReturn = ELASTIC_SEARCH_RETURNED_FIELDS.USER_RETURNED_FIELDS;

    if (whiteListedMachineryGroups && whiteListedMachineryGroups.length > 0) {
      request.whiteListFilter = [new ElasticSearchFilterValue(this.MACHINE_GROUP_FIELD, String(whiteListedMachineryGroups.join(',')))];
    }

    request.filter = [new ElasticSearchFilterValue(this.MACHINE_GROUP_FIELD, String(machineryGroupId))];

    const url: string = this.BASE_URL + this.ELASTIC_API_PREFIX + ELASTIC_SEARCH_TYPE.USER + '/';
    return this.http.post(url, request, HTTPS_REQUEST_OPTIONS);

  }

  public listAssignedMachines(machineryGroupId: number | null, whiteListedMachineryGroups: number[] | null): Observable<any> {

    const request = this.generateElasticRequest();
    request.sort = new ElasticSearchSortValue(this.NAME_FIELD, ELASTIC_SEARCH_SORT_ORDER.ASC);
    request.fieldsToSearch = ELASTIC_SEARCH_FIELDS.MACHINE_SEARCH_FIELDS;
    request.fieldsToReturn = ELASTIC_SEARCH_RETURNED_FIELDS.MACHINE_RETURNED_FIELDS;

    if (whiteListedMachineryGroups && whiteListedMachineryGroups.length > 0) {
      request.whiteListFilter = [new ElasticSearchFilterValue(this.PARENT_MACHINERY_GROUP_IDS_FIELD, String(whiteListedMachineryGroups.join(',')))];
    }

    request.filter = [new ElasticSearchFilterValue(this.PARENT_MACHINERY_GROUP_IDS_FIELD, String(machineryGroupId))];

    const url: string = this.BASE_URL + this.ELASTIC_API_PREFIX + ELASTIC_SEARCH_TYPE.MACHINE + '/';
    return this.http.post(url, request, HTTPS_REQUEST_OPTIONS);

  }

  private generateElasticRequest(): ElasticSearchRequest {
    const request = new ElasticSearchRequest();
    request.searchText = '*';
    request.from = this.INITIAL_PAGE_NUMBER;
    request.size = this.MAX_ITEMS_PER_PAGE;

    return request;
  }


}